import React from 'react'
import './AdminDashboard.css'
import { App, Space} from "antd"
import AdminFooter from '../../Components/Admin/AdminFooter/AdminFooter'
import AdminHeader from '../../Components/Admin/AdminHeader/AdminHeader'
import AdminSideMenu from '../../Components/Admin/AdminSideMenu/AdminSideMenu'
import AdminContent from '../../Components/Admin/AdminContent/AdminContent'
function AdminDashboard() {
  return (
    <div className='admin-dashboard-container'>
    <div className='wrapper'>
        {/* <AdminHeader/> */}
        <Space className='adminSideMenuAndContent'>
            <AdminSideMenu/>
            <AdminContent/>
        </Space>
        {/* <AdminFooter/> */}
    </div>
    </div>
  )
}

export default AdminDashboard